// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:400px){.phone-section[data-v-3a321f88]  .form-input .input-group .append{bottom:calc(100% + 10px)!important;right:0!important}}.check-phone-verification-button[data-v-3a321f88]{margin-top:12px;margin-left:0!important}", ""]);
// Exports
module.exports = exports;
